import axios from "axios"

export async function submitContactForm(formData) {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/contact`,
      formData,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    )

    if (response.status === 200) {
      return response.data
    } else {
      console.error("Request failed:", response)
      return { success: false, message: "Unexpected response status" }
    }
  } catch (error) {
    console.error("Error submitting contact form:", error)
    return { success: false, message: error.response?.data || error.message }
  }
}
